
import { gsap, ScrollTrigger, scrollSmootherInstance } from '../globals/gsap';

class Gallery {
  constructor($el) {
    this.$el = $el;
    this.$slider = this.$el.find('[data-gallery="slider"]');
    this.$items = this.$el.find('[data-gallery="item"]');
    this.id = `gallery-${Date.now()}`;
    this.touchX = 0;
    this.init();
  }
  
  init = () => {
    gsap.to(this.$slider, {
      x: () => `-=${this.calculateOffset()}px`,
      ease: 'none',
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: this.$el,
        start: 'clamp(center center)',
        end: () => `+=${this.calculateOffset()}px`,
        scrub: true,
        pin: true,
        pinSpacing: true,
        markers:false,
        id: this.id,
      },
    });

    // this.initScrollX();
  }

  initScrollX = () => {
    this.$slider.on('wheel', (event) => {
      window.scrollBy({ top: event.originalEvent.deltaX, left: 0 });
    });

    this.$slider.on('touchstart', (event) => {
      this.touchX = event.originalEvent.touches[0].clientX;
      console.log('touchX', this.touchX);
    });

    this.$slider.on('touchmove', (event) => {
      const touchX = event.originalEvent.touches[0].clientX;
      const diff = this.touchX - touchX;

      window.scrollBy({ top: diff, left: 0 });

      this.touchX = touchX;
    });
  }

  


  calculateOffset = () => {

    const { $slider } = this;
    const sliderWidth = $slider.width();
    const sliderScrollWidth = $slider.get(0).scrollWidth;
    const sliderWidthDiff = sliderScrollWidth - sliderWidth;

    return Math.max(0,sliderWidthDiff);
  }
}

export default Gallery;